export default __webpack_public_path__ + "static/media/regular-timeline-post.6ecc9b02.svg";